module.exports = __webpack_public_path__ + "img/feature-work-4.7b509a72.jpg";